import { CREATE_MEDICINES_CART } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    eka_mx?: EkaMxEntity[] | null;
    cart_mx?: CartMxEntity[] | null;
    unavailable_mx?: CartMxEntity[] | null;
    vendor: string;
    vendor_error: string;
    totalMRP: number;
    absoluteDiscount: number;
    discountedPrice: number;
    totalAmount: number;
    discount: number;
    extra_charges?: ExtraCharges;
    eta?: string;
    eta_display?: string;
    cart_pdf_url?: string;
    in_clinic_max_discount: number;
    paymodes: string[];
    fareDict: FareDict;
    error?: string;
}

export interface FareDict {
    gross_amt: number;
    discount_percent: number;
    discount_amount: number;
    net_amount: number;
    mrp: number;
    extra_charges: ExtraCharges;
    total_price: number;
    eka_net_price: number;
    min_sell_price: number;
    max_sell_price: number;
}

export interface ExtraCharges {
    total_amount: number;
    details: Detail[];
    total: number;
}

export interface Detail {
    display_text: string;
    amount: number;
    type: string;
}

export interface EkaMxEntity {
    id: string;
    name: string;
    dosage_form: string;
    df_id: string;
    dose: DoseOrDuration;
    generic_name: string;
    frequency: Frequency;
    timing: string;
    duration: DoseOrDuration;
    product_type: string;
    meta?: Meta | null;
    soa: boolean;
    kind?: string | null;
    track: Track;
}
export interface DoseOrDuration {
    custom: string;
    id: string;
    value: string;
    unit: string;
}
export interface Frequency {
    type: string;
    custom: string;
    value: string;
    id: string;
}
export interface Meta {
    updatedAt: number;
    isLocal: number;
    fCount: number;
}
export interface Track {
    label: string;
    index: number;
    source: string;
}
export interface CartMxEntity {
    eka_id: string;
    vendor_id: string;
    name: string;
    image: string;
    qty: number;
    manufacturer_name: string;
    product_type: string;
    product_sku: string;
    generic_name: string;
    price: number;
    totalamount: number;
    mrp: number;
    discount: number;
    isInvalidPrice?: boolean;
    status: string;
    min_qty: number;
    max_qty: number;
    is_otc: boolean;
    discount_allowed: boolean;
}

export interface ExtraCharges {
    details: Detail[];
    total_amount: number;
}

export interface Detail {
    type: string;
    display_text: string;
    amount: number;
}

interface Request {
    pxid?: string;
    pincode: string;
    docid: string;
    patientid: string;
    discount: number;
    eka_mx?: EkaMxEntity[];
    generate_pdf?: boolean;
}

export default (docid: string, request: Request): Promise<Response> => {
    return fetchWithRefresh(CREATE_MEDICINES_CART(docid), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
